import { render, staticRenderFns } from "./NavTools.vue?vue&type=template&id=8450a2b8"
import script from "./NavTools.vue?vue&type=script&lang=js"
export * from "./NavTools.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports